const Data = [
    {
      id: "1",
      title: "Javascript",
      category: "Front  End",
      img: "",
      desc: " Client  side  language",
    },
    {
      id: "2",
      title: "HTML",
      category: "Front  End",
      img: "",
      desc: "HTML Markup",
    },
    {
      id: "3",
      title: "CSS",
      category: "Front  End",
      img: "",
      desc: "CSS  Style",
    },
    {
      id: "4",
      title: "Angular",
      category: "Javascript Framework",

      img: "",
      desc: "JS Framework",
    },
    {
      id: "5",
      title: "Python",
      category: "Back End",
      img: "",
      desc: "Python use for Web developyment  BAckend and data  science",
    },
    {
      id: "6",
      title: "PHP",
      category: "Back End",
      img: "",
      desc: "php",
    },
    {
      id: "7",
      title: "Nodejs",
      category: "Back End",
      img: "",
      desc: "Nodejs",
    },
    {
      id: "8",
      title: "GoLang",
      category: "Back End",
      img: "",
      desc: "GOlang",
    },
    {
      id: "9",
      title: "React native",
      category: "Mobile",
      img: "",
      desc: "mobile",
    },
    {
      id: "10",
      title: "Flutter",
      category: "Mobile",
      img: "",
      desc: "mobile",
    },
  ];
  
  export default Data;
  